import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { IItemForGetShortInfo } from 'types';
import { Rule } from 'antd/lib/form';
import FormSelect from 'components/Select/FormSelect';

interface IProps {
	fetchedCustomers: IItemForGetShortInfo[];
}

export const CustomerSelect: React.FC<IProps> = React.memo(({ fetchedCustomers }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('selectCustomer') }], [t]);

	return (
		<FormSelect
			testId="CustomerSelect"
			name="IDSelectedCustomer"
			label="customerLabel"
			options={fetchedCustomers}
			validationRules={validationRules}
			disabled={true}
		/>
	);
});
